import ConfirmModal from 'components/ConfirmModal'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { sendGMBPIN, useRestaurants } from 'state/Restaurants'
import { Alerts, usePlainEffect } from 'utils'

export default function GMBModal({ show, doClose }) {
	const { t }       = useTranslation()
	const dispatch    = useDispatch()
	const restaurants = useRestaurants()

	//TODO I guess we could have an useFieldState() which returns { state, set, reset }; saves us from separate vars for the initial state, and cleans up repeated field names when creating the state
	const initialRestaurant             = restaurants.length > 1? 0 : restaurants[0].id
	const [pin, setPin]                 = useState('')
	const [restaurant, setRestaurant]   = useState(initialRestaurant)
	const [readyToSend, setReadyToSend] = useState(false)

	usePlainEffect(() => setReadyToSend(pin.length >= 5 && restaurant !== 0), [pin, restaurant])

	function setValidPin({ target }) {
		if (/^\d+$/.test(target.value) || target.value === '') {
			setPin(target.value)
		}
	}

	async function doSubmit() {
		if (!pin) {
			return
		}
		await dispatch(sendGMBPIN(restaurant, pin))
		Alerts.success(t('New GMB PIN sent successfully')) //FIXME replace this with a more meaningful sentence, such as "Thanks! We will be working on that shortly."
	}

	function beforeClose() {
		setPin('')
		setRestaurant(initialRestaurant)
	}

	return <ConfirmModal {...{ show, beforeClose, doClose, doSubmit }}
	                     confirmTexts={[t('Send'), t('Sending')]}
	                     confirmIcon="paper-plane"
	                     title={t('New GMB PIN')}
	                     disabled={!readyToSend}>
		<Form>
			<Form.Group controlId="pin">
				<Form.Label>{t('Google My Business PIN:')}</Form.Label>
				<InputGroup>
					<Form.Control maxLength={6} value={pin} onChange={setValidPin}/>
				</InputGroup>
			</Form.Group>

			{restaurants.length > 1 && <Form.Group controlId="location">
				<Form.Label>{t('Location:')}</Form.Label>
				<InputGroup className="flex-column">
					{restaurants.map(r => (
						<Form.Check
							key={r.id}
							id={`radio-${r.id}`}
							type="radio"
							value={r.id}
							label={r.display_name}
							checked={restaurant === r.id}
							onChange={() => setRestaurant(r.id)}
						/>
					))}
				</InputGroup>
			</Form.Group>}
		</Form>
	</ConfirmModal>
}

GMBModal.propTypes = {
	show   : PropTypes.bool.isRequired,
	doClose: PropTypes.func.isRequired,
}
